var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.68,208.72c-1.51-43.71-33.06-87.21-69.53-111.36s-89.84-25.22-121.29,5.17C248.45,130,240.19,178,204,193.82c-22.28,9.73-48,3.55-72.18,5.71-39.86,3.56-76.16,32.05-90,69.59s-5.13,82.24,21.09,112.47c18.52,21.36,53,39.1,81,43.19,62.52,13.05,158,11,193.33,0,44.28-13.85,68.15-31,96.59-77.74C461.54,301.47,469.63,265.05,467.68,208.72Z",
    style: {
      fill: "#E6EEF6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.1,469.83c0,.14-96.46.26-215.42.26S36.24,470,36.24,469.83s96.44-.26,215.44-.26S467.1,469.69,467.1,469.83Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character",
    "data-motion": "breathe",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.65,341.44s-28.44,19.32-30,64.42c-.52,15.13,6.91,63.3,6.91,63.3l166.33.67L305.78,340.72l-52.33-12Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.19 374.92 234.53 469.45 291.17 469.83 257.19 374.92",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.33,354.45a20.31,20.31,0,0,1,.3,3.09c.13,2.08.29,4.64.47,7.48s.28,5.57.32,7.48a17.76,17.76,0,0,1-.07,3.11,20.31,20.31,0,0,1-.3-3.09c-.13-2.07-.29-4.64-.47-7.47s-.28-5.57-.31-7.49A17.29,17.29,0,0,1,256.33,354.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,364.87c0,.05-.37.13-1,.48a4.82,4.82,0,0,0-1.89,2.1,4.07,4.07,0,0,0,.2,4,4.24,4.24,0,0,0,7.82-1.25,4.05,4.05,0,0,0-1-3.84,4.8,4.8,0,0,0-2.45-1.41c-.66-.15-1-.11-1.06-.16s.1,0,.28-.06a2.9,2.9,0,0,1,.82,0,4.71,4.71,0,0,1,2.67,1.35,4.79,4.79,0,0,1,1.14,1.78,4.36,4.36,0,0,1,.11,2.44,4.71,4.71,0,0,1-8.7,1.38,4.36,4.36,0,0,1-.65-2.35,4.8,4.8,0,0,1,.53-2,4.73,4.73,0,0,1,2.12-2.12,2.85,2.85,0,0,1,.77-.27C266.49,364.86,266.58,364.85,266.59,364.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.72,416.48s-.37.14-1,.48a4.81,4.81,0,0,0-1.88,2.1,4.07,4.07,0,0,0,.2,4,4.24,4.24,0,0,0,7.82-1.25,4.06,4.06,0,0,0-1-3.84,4.78,4.78,0,0,0-2.44-1.41c-.67-.15-1.06-.11-1.06-.16a.7.7,0,0,1,.28-.06,3.26,3.26,0,0,1,.81,0,4.73,4.73,0,0,1,2.68,1.36,4.65,4.65,0,0,1,1.13,1.77,4.19,4.19,0,0,1,.11,2.44,4.69,4.69,0,0,1-8.69,1.38,4.19,4.19,0,0,1-.65-2.35,4.66,4.66,0,0,1,.53-2,4.73,4.73,0,0,1,2.12-2.12,3.1,3.1,0,0,1,.77-.27A1,1,0,0,1,284.72,416.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,379a2.71,2.71,0,0,1-.36.44c-.24.28-.6.69-1.09,1.2a45,45,0,0,1-4.48,4,46.21,46.21,0,0,1-17.8,8.37,35.36,35.36,0,0,1-10.85.88,16.43,16.43,0,0,1-8.34-3,12.27,12.27,0,0,1-3.83-4.61,10.41,10.41,0,0,1-.54-1.54,2,2,0,0,1-.09-.56c.05,0,.2.76.82,2a12.4,12.4,0,0,0,3.86,4.39,16.42,16.42,0,0,0,8.16,2.85,36.14,36.14,0,0,0,10.7-.92,47.42,47.42,0,0,0,17.69-8.16,53.1,53.1,0,0,0,4.55-3.83l1.17-1.13C225.75,379.11,225.89,379,225.91,379Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,388.36a2.71,2.71,0,0,1-.36.44c-.24.28-.6.7-1.09,1.21a45,45,0,0,1-22.28,12.35,35.38,35.38,0,0,1-10.85.89,16.52,16.52,0,0,1-8.34-3,12.18,12.18,0,0,1-3.83-4.6,10.07,10.07,0,0,1-.54-1.55,1.93,1.93,0,0,1-.09-.56c.05,0,.2.76.82,2a12.42,12.42,0,0,0,3.86,4.4,16.42,16.42,0,0,0,8.16,2.84,35.81,35.81,0,0,0,10.7-.92,47.58,47.58,0,0,0,17.69-8.15,52.87,52.87,0,0,0,4.55-3.84l1.17-1.13A2.45,2.45,0,0,1,225.91,388.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.38,385.53a2.15,2.15,0,0,1,.07.4c0,.29.07.69.13,1.19.12,1.08.29,2.62.5,4.59.42,4,1.22,9.73,1.58,16.9a79.55,79.55,0,0,1-.25,11.73,50.52,50.52,0,0,1-3,13.13,33.9,33.9,0,0,1-8.09,12.45,29.85,29.85,0,0,1-6.36,4.7,25.63,25.63,0,0,1-7.68,2.71,23.43,23.43,0,0,1-15.55-2.88A30.22,30.22,0,0,1,178,440.17a40.57,40.57,0,0,1-5-12.49A58,58,0,0,1,171.62,416a114,114,0,0,1,1.2-16.93c.29-2,.51-3.5.66-4.57.08-.5.15-.89.19-1.19a2.39,2.39,0,0,1,.09-.4,2.11,2.11,0,0,1,0,.41c0,.3-.08.69-.14,1.19-.13,1.08-.32,2.62-.57,4.58a119.93,119.93,0,0,0-1,16.9,58.1,58.1,0,0,0,1.42,11.57,40.43,40.43,0,0,0,5,12.32A29.68,29.68,0,0,0,189,450a22.9,22.9,0,0,0,15.21,2.81,24.67,24.67,0,0,0,7.52-2.65,29.35,29.35,0,0,0,6.26-4.61,33.46,33.46,0,0,0,8-12.25,50.32,50.32,0,0,0,3-13,79.18,79.18,0,0,0,.31-11.67c-.31-7.15-1-12.91-1.41-16.9-.2-2-.33-3.55-.41-4.6,0-.5-.06-.9-.08-1.2S227.38,385.53,227.38,385.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.34,435.06c1.8,6.1,2.57,7.68,5.94,12.55a25.17,25.17,0,0,0,12.95,9.82,23.45,23.45,0,0,0,22.48-4c6.11-5.11,8.27-13,9.33-18.35-2.66,3.58-5.49,8.67-8.84,11.62S209.42,452.23,205,453c-6,1-13.15-.8-18.28-4.06s-8.23-9.1-11.41-13.87"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.62,396.27a17.18,17.18,0,0,0,12.59,9.87c5.41,1,12.42-.71,15.8-5.79-11.9,4.18-23.73,4.28-28.39-4.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.41,381.52a2.27,2.27,0,0,1-.77,0,12.9,12.9,0,0,1-2-.44,19.11,19.11,0,0,1-10.75-8.16,14.61,14.61,0,0,1-1-1.84c-.19-.46-.28-.71-.24-.73s.54.94,1.52,2.37a22.07,22.07,0,0,0,4.64,4.85,21.75,21.75,0,0,0,5.92,3.16C276.36,381.24,277.42,381.43,277.41,381.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.57,371c1.23,4.18,5.87,8.08,10,9.45a6.09,6.09,0,0,0,2.53.37,2.94,2.94,0,0,0,2.18-1.21c.87-1.33.12-3.22-1.16-4.16a11.62,11.62,0,0,0-4.46-1.59c-3.19-.74-6.07.87-8.71-1.81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.13,363.26c7.46,6.52,18,6.8,27.49,4s17.76-8.07,25.82-13.83c-8.79,1.75-16.29,5.76-25.16,7.07-8.47,1.25-17.28,1.38-25.61-1.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,463.42a.58.58,0,0,1-.19.11,5.12,5.12,0,0,1-.59.27,8.85,8.85,0,0,1-2.43.6,13.38,13.38,0,0,1-8.73-2.34c-3.32-2.11-6.34-5.66-9.57-9.6a103.77,103.77,0,0,1-9.31-13.74,116.18,116.18,0,0,1-11.29-27.9c-1-3.74-1.58-6.8-1.95-8.93-.16-1-.29-1.85-.39-2.45a7.68,7.68,0,0,1-.1-.86,4.56,4.56,0,0,1,.21.84l.48,2.43c.43,2.11,1.1,5.16,2.1,8.87a121.3,121.3,0,0,0,11.39,27.74,107.1,107.1,0,0,0,9.24,13.7c3.19,3.94,6.17,7.49,9.39,9.59A13.4,13.4,0,0,0,315,464.2,12.11,12.11,0,0,0,318.19,463.42Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.23,426.52s14.76,18.56,25.53,23.11c3.65,1.55,7.67,2.81,10.16,5.89a6.47,6.47,0,0,1,1.55,5.22,2.88,2.88,0,0,1-.2.64c-1.55,3.95-9,3.4-12.41.9-1.49-1.09-.61-.39-1.81-1.29C301.6,458.39,283.13,437,282.23,426.52Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "217.07 176.02 226.49 174.15 273.08 174.7 296.75 179.9 305.78 312.08 201.13 316.97 217.07 176.02",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,306l2.23-60.12-3.71-69.71c14.72,3.79,34.85,8,46,20.71,7.23,8.25,14.32,18.8,17,35.79,3.08,20,7.14,58.25,9.68,79.65",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,296.14l-72.35,11.75-2.56-44.68-4-88.33c-21,.86-44.9,18.21-52.07,31.73-5,9.38-9.19,20.28-10.5,30.83-2.51,20-6.76,54.27-9.3,75.68A44.11,44.11,0,0,0,161,349h0c10.5,10.83,26.94,14.58,41.72,11.52l110.16-31Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,295.34a1,1,0,0,1,.05-.25q.09-.27.21-.72c.21-.67.49-1.6.86-2.79.78-2.46,1.89-6,3.27-10.38l11.35-35.44.15.31-11.73-4.85-.46-.19.41-.27,2.71-1.78,8.85-5.78-.1.28c-4.5-15.62-8.46-29.4-11.31-39.31-1.39-4.92-2.51-8.88-3.3-11.64-.36-1.35-.65-2.4-.86-3.15q-.13-.49-.21-.81a1.06,1.06,0,0,1-.06-.28s0,.08.1.26l.26.81c.23.74.55,1.78.95,3.12l3.45,11.59,11.47,39.27.05.18-.16.11-8.84,5.79-2.71,1.77,0-.46,11.72,4.87.22.09-.07.22c-4.62,14.19-8.65,26.54-11.53,35.39-1.45,4.38-2.6,7.89-3.41,10.33-.4,1.18-.72,2.11-.94,2.77-.1.29-.19.52-.25.71A1.17,1.17,0,0,1,292,295.34Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308,233.56a10.4,10.4,0,0,1-3.64,5.47c-1.38.79-.59,1.84.55,2.94,1.37,1.32,3.57,1.68,4.58,3.28s.44,3.43-.08,5.11A371,371,0,0,1,291.21,297L308,245.83,296.29,241Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,296.58a.88.88,0,0,1-.12-.21c-.07-.16-.17-.36-.28-.62l-1.08-2.44c-.94-2.16-2.28-5.27-4-9.15L202.3,252.54l-.08-.18.17-.12,9.25-6.62V246l-6.13-4.86L202.79,239,201.44,238l-.33-.27a1.15,1.15,0,0,1-.19-.17.81.81,0,0,1-.14-.28,3.76,3.76,0,0,1-.11-.91,51.63,51.63,0,0,1,.62-6.68c.61-4.33,1.33-8.49,2-12.45,1.42-7.91,2.83-15,4-21s2.22-10.77,2.93-14.09c.36-1.64.65-2.92.85-3.83l.23-1a1.2,1.2,0,0,1,.1-.33,1.85,1.85,0,0,1-.05.35c0,.25-.11.58-.18,1q-.27,1.37-.75,3.84c-.66,3.36-1.6,8.18-2.76,14.12s-2.52,13.07-3.92,21c-.69,3.95-1.4,8.11-2,12.43a51.56,51.56,0,0,0-.61,6.6,3,3,0,0,0,.09.76c0,.12.29.3.5.48l1.34,1.06,2.71,2.15,6.12,4.85.27.22-.28.2-9.26,6.6.08-.31L216.11,284c1.63,3.91,2.93,7,3.83,9.21.43,1.05.77,1.87,1,2.47l.24.64A1.63,1.63,0,0,1,221.27,296.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.75,
    y: 246.96,
    width: 78.58,
    height: 107.94,
    rx: 2.41,
    transform: "translate(49 -36.76) rotate(8.77)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224.75,
    y: 246.96,
    width: 78.58,
    height: 107.94,
    rx: 2.41,
    transform: "translate(49 -36.76) rotate(8.77)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 229.36,
    y: 249.27,
    width: 69.81,
    height: 100.48,
    transform: "translate(48.78 -36.81) rotate(8.77)",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.72,253.53a8.57,8.57,0,0,0-6.85-5.83l.58-4.25a5.88,5.88,0,0,0-4.91-6.7h0a5.88,5.88,0,0,0-6.71,4.91l-.68,4.4-1.48-.2a8.53,8.53,0,0,0-8.15,3.54L256.37,251l30,4.64Zm-12.4-7.76a3.16,3.16,0,1,1,3.6-2.64A3.17,3.17,0,0,1,273.32,245.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,262.55a84.92,84.92,0,0,1-9.4-1.18,88.11,88.11,0,0,1-9.31-1.7,84.91,84.91,0,0,1,9.39,1.18A88,88,0,0,1,260.83,262.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,264.21a19.37,19.37,0,0,1-4.55-.44,20.23,20.23,0,0,1-4.47-.95,20.75,20.75,0,0,1,4.55.44A20.23,20.23,0,0,1,250.65,264.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.24,279.79c0,.14-11.7-1.55-26.07-3.76s-26-4.14-26-4.28,11.69,1.54,26.07,3.76S293.26,279.64,293.24,279.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.47,284.75c0,.14-11.69-1.54-26.07-3.76s-26-4.13-26-4.27,11.69,1.54,26.07,3.76S292.49,284.61,292.47,284.75Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.71,289.72c0,.14-11.7-1.55-26.07-3.76s-26-4.14-26-4.28,11.7,1.54,26.08,3.76S291.73,289.57,291.71,289.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,294.68c0,.14-11.69-1.54-26.07-3.76s-26-4.13-26-4.28,11.69,1.55,26.07,3.77S291,294.54,290.94,294.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17,299.64c0,.15-11.69-1.54-26.07-3.76s-26-4.13-26-4.27,11.69,1.54,26.07,3.76S290.2,299.5,290.17,299.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,304.61c0,.14-11.7-1.54-26.07-3.76s-26-4.13-26-4.28,11.69,1.54,26.07,3.76S289.43,304.47,289.41,304.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,305.07a4.53,4.53,0,0,1-1-.06c-.67-.07-1.62-.19-2.8-.35-2.37-.32-5.63-.79-9.22-1.34s-6.84-1.09-9.19-1.5c-1.18-.2-2.12-.38-2.78-.51a3.8,3.8,0,0,1-1-.26,3.91,3.91,0,0,1,1,.06c.67.07,1.62.19,2.8.35,2.37.31,5.63.79,9.22,1.34s6.84,1.09,9.19,1.5c1.18.2,2.12.38,2.78.51A3.8,3.8,0,0,1,262.69,305.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,267.74a17.27,17.27,0,0,1-4.21-.39,17.08,17.08,0,0,1-4.13-.9,34.62,34.62,0,0,1,8.34,1.29Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.18,314.06a45.35,45.35,0,0,1-6.8-.79,44.76,44.76,0,0,1-6.72-1.3,45.22,45.22,0,0,1,6.8.79A45.6,45.6,0,0,1,249.18,314.06Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,318.64a47.06,47.06,0,0,1-6.92-.81,44.6,44.6,0,0,1-6.83-1.32,46.86,46.86,0,0,1,6.91.81A44.58,44.58,0,0,1,248.94,318.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,319.44a21.34,21.34,0,0,1-6.53-1,11,11,0,0,1,3.31.24A10.24,10.24,0,0,1,288.5,319.44Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1,323.53a21.34,21.34,0,0,1-6.53-1,21.34,21.34,0,0,1,6.53,1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9,322.4a10.45,10.45,0,0,1-3.2-.23,9.91,9.91,0,0,1-3.11-.75,10,10,0,0,1,3.19.23A9.8,9.8,0,0,1,241.9,322.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,328.3a5.85,5.85,0,0,1-2.41-.11,5.78,5.78,0,0,1-2.33-.62,5.56,5.56,0,0,1,2.41.1A5.69,5.69,0,0,1,287.6,328.3Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52,332.05a6.68,6.68,0,0,1,1.18,0l3.32.1,11.86.47.27,0-.06.26a5.68,5.68,0,0,1-2.08,3.23,4.71,4.71,0,0,1-4,.91,4.66,4.66,0,0,1-3.29-2.85,4,4,0,0,1,1.22-4.32,3.67,3.67,0,0,1,1.58-.84,2.34,2.34,0,0,1,.45-.07,2,2,0,0,1,.49,0,.69.69,0,0,1,.51.38,1.07,1.07,0,0,1,.06.54,7.83,7.83,0,0,1-1.09,3.16,8,8,0,0,1-2.21,2.34,5,5,0,0,1-3,1,2.81,2.81,0,0,1-2.4-1.73,4.21,4.21,0,0,1-.2-2.79,10.1,10.1,0,0,1,2.8-4l.27-.27,0,.38a6.82,6.82,0,0,1-.76,4,7.21,7.21,0,0,1-2,2.37,6.26,6.26,0,0,1-1.71.94,2.42,2.42,0,0,1-.66.16,8.06,8.06,0,0,0,2.25-1.26,7.28,7.28,0,0,0,1.85-2.34,6.54,6.54,0,0,0,.65-3.84l.32.1a9.87,9.87,0,0,0-2.65,3.88,3.77,3.77,0,0,0,.2,2.49,2.34,2.34,0,0,0,2,1.44,4.42,4.42,0,0,0,2.64-.91,7.31,7.31,0,0,0,3.07-5.14.55.55,0,0,0,0-.27c0-.05,0-.07-.14-.09a2.37,2.37,0,0,0-.72.07,3.26,3.26,0,0,0-1.36.72,3.53,3.53,0,0,0-1.07,3.76,4.18,4.18,0,0,0,6.51,1.72,5.17,5.17,0,0,0,1.93-2.94l.21.27L238,332.39l-3.32-.22A9.36,9.36,0,0,1,233.52,332.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,339.5a2.81,2.81,0,0,1-.57.6,3.57,3.57,0,0,1-.85.54,1.92,1.92,0,0,1-1.37.07,1.33,1.33,0,0,1-.7-.51,1.79,1.79,0,0,1-.28-.88,15.92,15.92,0,0,1,.14-1.91c.13-1.36.28-2.85.44-4.46l.43.17-3.82,5.17-.95,1.28-.62.84.15-1c.41-2.67.78-5.16,1.11-7.35l.37.2a23.44,23.44,0,0,0-4.11,4.5c-.84,1.21-1.24,2-1.29,1.94a2.15,2.15,0,0,1,.23-.57,16.53,16.53,0,0,1,.85-1.51,21.24,21.24,0,0,1,4-4.7l.45-.39-.09.6c-.3,2.18-.66,4.68-1,7.36l-.47-.2,1-1.28c1.36-1.82,2.65-3.56,3.85-5.15l.53-.72-.1.89c-.19,1.61-.36,3.1-.52,4.45a17.14,17.14,0,0,0-.18,1.85,1.13,1.13,0,0,0,.72,1.13,2.18,2.18,0,0,0,2-.46A5,5,0,0,1,282.94,339.5Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.7,336.78a93.08,93.08,0,0,1-9.81.21,93.14,93.14,0,0,1-9.8-.3,91.2,91.2,0,0,1,9.8-.22A91.5,91.5,0,0,1,284.7,336.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,339.89a61.36,61.36,0,0,1-7.84,1.11,61.88,61.88,0,0,1-7.89.6,57.59,57.59,0,0,1,7.84-1.12A58.54,58.54,0,0,1,287.89,339.89Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.93,236.93c-.12,3,.69,6.06,3.19,7.75-3.13,1.52-4.8,5.16-4.9,8.64s1.11,6.86,2.42,10.09c4.05,9.93,12.69,23.91,19.28,32.37,0,0-3.34-9-4.3-11.11-4.34-9.49-8.17-19-12.52-28.52-.48-1-1.34-3.92-1.34-3.92a5.55,5.55,0,0,0,1.3-.89c2.44-2,7.73-5.51,7.73-5.51s-10.86-8.6-10.86-8.9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M200.78,257.33c.14,0-.11,11.55-.57,25.78s-.94,25.77-1.08,25.76.1-11.54.56-25.78S200.63,257.32,200.78,257.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,227l-1,0c0-.38,1.45-38.21,2.58-53.27a7.77,7.77,0,0,1,2.63-5.56c3.12-2.67,7.79-2.32,8-2.31l-.08,1c-.05,0-4.46-.32-7.26,2.07a6.86,6.86,0,0,0-2.29,4.88C219.48,188.76,218.05,226.58,218,227Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.37,290.28H225.6v-2h1.77a7,7,0,0,0,7-7V260.1h2v21.18A9,9,0,0,1,227.37,290.28Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.09,289.52a2.15,2.15,0,1,1-1.93-2.35A2.16,2.16,0,0,1,228.09,289.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,290.23H208.3a9,9,0,0,1-9-9l.08-21.18h2l-.08,21.18a7,7,0,0,0,7,7h1.77Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,289.46a2.14,2.14,0,1,0,1.93-2.34A2.14,2.14,0,0,0,207.59,289.46Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,262.49l-.25-15.1c-.19-11.51,8.22-21,18.75-21.19a18.28,18.28,0,0,1,13.65,5.94,21.8,21.8,0,0,1,5.79,14.61l.25,15.11-3,.05-.25-15.11a18.77,18.77,0,0,0-5-12.61,15.2,15.2,0,0,0-11.41-5c-8.88.15-16,8.28-15.8,18.14l.25,15.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,227.56c0-.4-4.59-39.71-5.91-52.31l-.09-.92c-.41-4.28-.89-9.12-5.62-10.4l.26-1c5.4,1.46,5.93,6.9,6.36,11.27l.09.91c1.31,12.6,5.86,51.91,5.9,52.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.71,
    cy: 220.82,
    r: 10.73,
    transform: "translate(-72.75 266) rotate(-45)",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.89,220.82a5.19,5.19,0,1,1-5.18-5.19A5.18,5.18,0,0,1,289.89,220.82Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,296.58,207.8,329.71,315.25,359.5a34.46,34.46,0,0,0,29.06-5h0c11.24-7.93,14-21.8,12.63-35.53L355,304.37Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,332.54c-.11,0-.34-2.26-1.45-5.75a29,29,0,0,0-1-2.81c-.38-1-.91-2-1.44-3.12a41.54,41.54,0,0,0-4.33-6.55,42.07,42.07,0,0,0-5.56-5.54c-1-.73-1.86-1.46-2.77-2a29,29,0,0,0-2.55-1.57c-3.2-1.77-5.39-2.45-5.35-2.56a8.33,8.33,0,0,1,1.53.47,15.19,15.19,0,0,1,1.75.69c.67.31,1.45.62,2.25,1.08a26.55,26.55,0,0,1,2.61,1.53c.93.56,1.85,1.29,2.83,2a40.67,40.67,0,0,1,5.67,5.58,39.93,39.93,0,0,1,4.34,6.66c.53,1.11,1.05,2.15,1.42,3.18a26.31,26.31,0,0,1,1,2.86,20.91,20.91,0,0,1,.61,2.42A12.37,12.37,0,0,1,335,331,8.48,8.48,0,0,1,335.11,332.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.4,310.68c-8.2.68-14.53,1.43-23,2.47-5.29.65-10.78.28-12.51-4.75s-.63-10.79,2.21-15.3,7.3-15,31.18-7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.46,309.23l.06-.22.23-.66.9-2.52,3.45-9.31.05-.13h.13l36.55,3.31,35.36,3.36,10.71,1.07,2.91.32.75.1a.82.82,0,0,1,.26.05h-.26l-.76,0-2.92-.22-10.73-.92-35.37-3.2-36.53-3.47.18-.12-3.6,9.26-1,2.48-.27.64C216.51,309.17,216.47,309.24,216.46,309.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.67,343.4c15.26,4.09,24.54,1.72,38.4-5.86a74.57,74.57,0,0,0,8.16-5.54,29.49,29.49,0,0,0,5.23-5.55c-17.85,6.83-32.68,12-51.08,17.14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.51,308.87l3.49-9.75-8.11-12.68a9.57,9.57,0,0,0-6.28-4.25l-29.84-5.63a4.81,4.81,0,0,0,2.52,5.87c3.91,2.23,21.5,6.32,21.5,6.32l-27.09-.46s-.84,3.91,2.23,5.31,22.37,2.11,22.37,2.11l-24.71,3.48s-.14,3.92,5.51,4a163.46,163.46,0,0,0,16.65-1.05.89.89,0,0,1,1,.73h0a.89.89,0,0,1-.67,1l-16.43,3.88a2.2,2.2,0,0,0-.16,4.25,2.69,2.69,0,0,0,.91.06c2.8-.28,19.52-2.4,19.52-2.4l.87,1.95,16.72-2.72",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,305.86a5.58,5.58,0,0,0-.92-1.48,4.07,4.07,0,0,0-1.58-1,6.15,6.15,0,0,0-2.28-.25c-1.66.12-3.16.6-4.28.74a3.9,3.9,0,0,1-1.84,0,15.4,15.4,0,0,1,1.77-.39,26.91,26.91,0,0,1,4.32-.9,6.1,6.1,0,0,1,2.48.32,4.27,4.27,0,0,1,1.68,1.18A2.11,2.11,0,0,1,204.24,305.86Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,298.43c-.05,0-.08-.27-.3-.7a3.44,3.44,0,0,0-1.42-1.4c-1.51-.88-4.06-.59-6.74-.41s-5.14.58-6.91.81a16.67,16.67,0,0,1-2.88.29,14.57,14.57,0,0,1,2.82-.65,69.4,69.4,0,0,1,6.92-1,37.3,37.3,0,0,1,3.86-.15,6.14,6.14,0,0,1,3.11.76,3.32,3.32,0,0,1,1.42,1.64A1.32,1.32,0,0,1,206.94,298.43Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,294.11a4.88,4.88,0,0,0-.63-2.26,5.13,5.13,0,0,0-1.8-1.75,8,8,0,0,0-3-.88c-2.24-.21-4.34,0-5.87-.12a5.24,5.24,0,0,1-2.39-.58c0-.08.92.19,2.41.22s3.56-.25,5.91,0a7.52,7.52,0,0,1,3.17,1,5.16,5.16,0,0,1,1.88,2,3.59,3.59,0,0,1,.45,1.78C209.11,293.89,209,294.11,209,294.11Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.87,294.08a9.22,9.22,0,0,1,.15-1.62c.13-1,.38-2.54.73-4.38.69-3.68,1.91-8.71,3.2-14.26a128.44,128.44,0,0,0,2.61-14.34c.12-.93.17-1.77.24-2.51s.11-1.37.13-1.9a8.56,8.56,0,0,1,.14-1.62,9.94,9.94,0,0,1,.06,1.63c0,.52,0,1.17,0,1.91s-.06,1.59-.17,2.52a105.9,105.9,0,0,1-2.46,14.43c-1.3,5.56-2.57,10.56-3.35,14.22-.39,1.82-.7,3.31-.89,4.33A10.07,10.07,0,0,1,305.87,294.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,359.68a2,2,0,0,1-.59-.1l-1.66-.37-6.08-1.5c-5.13-1.29-12.2-3.16-20-5.32s-14.79-4.23-19.84-5.78l-6-1.86-1.62-.54A2.27,2.27,0,0,1,260,344a2.17,2.17,0,0,1,.58.12l1.65.44,6,1.71,19.88,5.63L308,357.36l6,1.65,1.64.47A3,3,0,0,1,316.24,359.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3,69.63c2.2-6.79,13.47-12.92,19.65-16.48,9.25-5.31,17.82-4.25,23.1.48,9.54-8,22.11-15.7,34.16-12.55s21.84,15.49,19.64,27.76c-1.29,7.23-6.3,13.71-6,21,.2,5,2.85,9.52,5,14.06s3.73,9.82,1.85,14.46c-1.75,4.31-6.12,7-8.47,11-1.92,3.28-2.36,7.18-3.59,10.77-4.54,13.3-20.24,20.76-34.1,18.42s-25.41-12.77-32-25.21-8.71-26.72-9.47-40.75",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,79l2.77,110.9c1,12.71,12.71,22,26.31,20.82h0c13.73-1.18,24.22-12.55,23.43-25.41-.83-13.49-1.45-27.72-1.45-27.72s17.19-4,19.33-26.92c1.09-11.74-.81-31-2.8-46.26A22.74,22.74,0,0,0,264.7,64.89",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,100.8a2.9,2.9,0,0,1-2.61,3.11,2.78,2.78,0,0,1-3.17-2.42,2.92,2.92,0,0,1,2.61-3.12A2.79,2.79,0,0,1,286,100.8Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,97.84c-.34.4-2.65-1.09-5.78-.88s-5.32,1.92-5.68,1.56c-.18-.16.14-.86,1.09-1.66a8,8,0,0,1,4.53-1.72,7.72,7.72,0,0,1,4.62,1.17C288.68,97,289.05,97.65,288.89,97.84Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,103.94a2.9,2.9,0,0,1-2.61,3.12,2.79,2.79,0,0,1-3.17-2.43,2.92,2.92,0,0,1,2.61-3.12A2.79,2.79,0,0,1,256,103.94Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.16,100.41c-.34.4-2.65-1.09-5.78-.88s-5.32,1.92-5.68,1.56c-.18-.16.14-.86,1.1-1.66a8,8,0,0,1,4.52-1.72,7.72,7.72,0,0,1,4.62,1.17C258,99.56,258.32,100.22,258.16,100.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,122.88c0-.17,1.89-.63,5-1.24.79-.13,1.54-.34,1.64-.9a4.05,4.05,0,0,0-.69-2.33c-.87-1.89-1.79-3.86-2.75-5.93-3.84-8.46-6.68-15.43-6.34-15.58s3.73,6.58,7.58,15c.92,2.08,1.81,4.07,2.65,6a4.57,4.57,0,0,1,.62,3.11,2,2,0,0,1-1.24,1.25,5,5,0,0,1-1.34.27C273,122.92,271,123.06,271,122.88Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.58,157.55a57.82,57.82,0,0,1-30.9-6.14s8.59,15.27,31.15,11.68Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,88.09c-.26.87-3.41.67-7.05,1.35s-6.55,1.87-7.09,1.14c-.24-.35.23-1.19,1.37-2.09a12,12,0,0,1,5.16-2.19,12.12,12.12,0,0,1,5.61.29C257.56,87.05,258.28,87.68,258.18,88.09Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.15,88.85c-.5.75-2.71.15-5.3.28s-4.76.79-5.31.08c-.25-.35,0-1.08,1-1.82a7.68,7.68,0,0,1,8.55-.28C287,87.78,287.37,88.49,287.15,88.85Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,128.77c2.45,0,3.67.72,5.75,2a3.59,3.59,0,0,1,1.48,1.46,3.1,3.1,0,0,1-.31,2.72,5.47,5.47,0,0,1-5.19,2.77,5,5,0,0,1-4.35-3.85,4.69,4.69,0,0,1,2.62-5.12",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.47,134c0,.24-.78.6-2.15.52a11.65,11.65,0,0,1-4.9-1.6,13.63,13.63,0,0,1-3.93-3.29c-.81-1-1.06-1.88-.85-2,.41-.27,2.47,1.89,5.71,3.67a24.78,24.78,0,0,0,4.21,1.93C273.68,133.61,274.44,133.74,274.47,134Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.02,
    cy: 113.65,
    r: 0.83,
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,109.58a.83.83,0,1,1-.83-.83A.83.83,0,0,1,283.35,109.58Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94,111.74a.84.84,0,1,1-1.67,0,.84.84,0,0,1,1.67,0Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,108.27a.83.83,0,1,1-.83-.83A.83.83,0,0,1,289.33,108.27Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.05,117.32a.84.84,0,1,1-.84-.83A.84.84,0,0,1,256.05,117.32Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.93,114a.83.83,0,1,1-.83-.83A.83.83,0,0,1,252.93,114Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.53,103.94a22.93,22.93,0,0,0-.55-3.5,14.37,14.37,0,0,0-5.26-7.83,14.07,14.07,0,0,0-6-2.64,14.28,14.28,0,0,0-7.46.63,13.29,13.29,0,0,0-3.58,1.94,13.6,13.6,0,0,0-3,3,14.16,14.16,0,0,0,0,16.77,14.38,14.38,0,0,0,6.58,5,14.28,14.28,0,0,0,7.46.63,14.07,14.07,0,0,0,6-2.64,14.39,14.39,0,0,0,5.26-7.82,23.32,23.32,0,0,0,.55-3.5.6.6,0,0,1,0,.23v.69a7.13,7.13,0,0,1-.09,1.12,9.79,9.79,0,0,1-.27,1.5,13.63,13.63,0,0,1-1.56,3.9,14.55,14.55,0,0,1-17.52,6.34,14,14,0,0,1-3.72-2,13.7,13.7,0,0,1-3.11-3.11,14.58,14.58,0,0,1,0-17.37,13.7,13.7,0,0,1,3.11-3.11,14,14,0,0,1,3.72-2,14.65,14.65,0,0,1,7.7-.6,14.62,14.62,0,0,1,9.82,6.94,13.74,13.74,0,0,1,1.56,3.9,9.69,9.69,0,0,1,.27,1.51,6.93,6.93,0,0,1,.09,1.11v.69A.64.64,0,0,1,266.53,103.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,99.57a11.37,11.37,0,0,0-3.42-.4,11.9,11.9,0,0,0-3.27,1.1s.21-.38.77-.76a5.57,5.57,0,0,1,2.44-.86,5.39,5.39,0,0,1,2.58.34C272.52,99.24,272.83,99.51,272.8,99.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.66,61.65c-2,18.07-15.44,34.34-32.78,39.82,5.59,8.06,2.07,23.4,2.21,36.2.14,11.9.13,15.3-7.58,21.37-6.37,1.53-10-15.92-14.78-20.8s-9.27-10.89-8.92-17.67c.17-3.18,1.41-6.22,1.58-9.39.2-3.52-.93-7-1.55-10.43C199.08,85.4,207,68.89,220.41,60.86s31.22-7.49,44.49.72",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,135.94A43.8,43.8,0,0,0,217,120l.29.62a19.63,19.63,0,1,0-30.23,23.22c-2.25-.5-4.53,1.44-5,3.69a8.55,8.55,0,0,0,1.69,6.52c4.69,6.86,15.32,8.67,22,3.75,5.3,3.59,13.13,1.5,17.06-3.55S227.2,142.08,225.39,135.94Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,109.47a4.89,4.89,0,0,1-.57-.64,6.68,6.68,0,0,1-1-2.21c-.61-2.07-.32-5.34,1.32-8.8a17.37,17.37,0,0,1,3.62-5.07,33.93,33.93,0,0,1,5.44-4.63,28.53,28.53,0,0,1,7.07-3.54c2.59-.89,5.34-1.58,8.14-2.28s5.54-1.39,8.1-2.29a49.82,49.82,0,0,0,7.17-3.12A53.19,53.19,0,0,0,254,69.29a54.57,54.57,0,0,0,6.08-6.55c.66-.83,1.14-1.5,1.47-2a4.59,4.59,0,0,1,.53-.66,6.09,6.09,0,0,1-.44.72c-.31.47-.76,1.16-1.4,2a49.68,49.68,0,0,1-6,6.7,52.71,52.71,0,0,1-10.84,7.76,50.21,50.21,0,0,1-7.23,3.17c-2.59.91-5.34,1.61-8.14,2.32s-5.54,1.38-8.11,2.25a28.62,28.62,0,0,0-7,3.45,35.09,35.09,0,0,0-5.4,4.54A17.2,17.2,0,0,0,204,98c-1.65,3.37-2,6.56-1.45,8.59A7.85,7.85,0,0,0,203.92,109.47Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06,60.13a5.38,5.38,0,0,1-.47.57c-.32.37-.81.89-1.44,1.56a63.51,63.51,0,0,1-5.77,5.25,40.37,40.37,0,0,1-9.92,6,38.21,38.21,0,0,1-6.62,1.79c-2.33.47-4.76.83-7.24,1.21a80.51,80.51,0,0,0-13.79,2.89,30.31,30.31,0,0,0-10,5.53,19.73,19.73,0,0,0-4.82,6,19.3,19.3,0,0,0-.83,1.94,3.28,3.28,0,0,1-.29.68,5.25,5.25,0,0,1,.19-.71,14.25,14.25,0,0,1,.75-2,19.08,19.08,0,0,1,4.76-6.18,30,30,0,0,1,10.07-5.7,79.2,79.2,0,0,1,13.86-3c2.49-.37,4.91-.74,7.22-1.19a38.47,38.47,0,0,0,6.55-1.74,41,41,0,0,0,9.86-5.83A72.68,72.68,0,0,0,260,62.11l1.51-1.48A3.69,3.69,0,0,1,262.06,60.13Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.45,40.35c0,.11-1.95.18-5,1a23.41,23.41,0,0,0-2.44.78c-.87.29-1.75.72-2.7,1.14a30.28,30.28,0,0,0-10.42,8.28c-.62.83-1.24,1.59-1.72,2.38a22.15,22.15,0,0,0-1.31,2.19c-1.47,2.76-2,4.66-2.08,4.62a6.46,6.46,0,0,1,.34-1.32,11.41,11.41,0,0,1,.54-1.52,18.48,18.48,0,0,1,.88-2,19.65,19.65,0,0,1,1.27-2.26c.47-.8,1.08-1.59,1.7-2.44a32.69,32.69,0,0,1,4.81-4.83,32,32,0,0,1,5.79-3.58,26.09,26.09,0,0,1,2.76-1.11,25.29,25.29,0,0,1,4.58-1.14,11,11,0,0,1,1.6-.19A6,6,0,0,1,287.45,40.35Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,126.69s0-.07.15-.2l.47-.55c.42-.49,1.05-1.2,1.76-2.19a12.29,12.29,0,0,0,2-3.89,7,7,0,0,0,.21-2.69,7.69,7.69,0,0,0-1-2.85c-1.08-1.87-2.85-3.5-4.47-5.52A32.29,32.29,0,0,1,295.91,93a65.59,65.59,0,0,1-.24-9.75,33.92,33.92,0,0,0-.89-9.59A19.73,19.73,0,0,0,283.94,61.2a18.17,18.17,0,0,0-6.84-1.58,20,20,0,0,0-12.32,3.63l-.6.42c-.13.09-.2.14-.21.13a14.28,14.28,0,0,1,3.11-2.18,20,20,0,0,1,10-2.37,18.66,18.66,0,0,1,7,1.55,20.08,20.08,0,0,1,11.16,12.73,34.39,34.39,0,0,1,.91,9.73,65.82,65.82,0,0,0,.23,9.68A31.88,31.88,0,0,0,303,108.53c1.58,2,3.36,3.66,4.46,5.61a7.87,7.87,0,0,1,1,3,7.19,7.19,0,0,1-.26,2.81,12.12,12.12,0,0,1-2.13,3.93,24.7,24.7,0,0,1-1.84,2.14l-.52.52A.87.87,0,0,1,303.56,126.69Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,100.41a23.13,23.13,0,0,0-.55-3.5,14.37,14.37,0,0,0-5.26-7.83,14.26,14.26,0,0,0-13.46-2,14.38,14.38,0,0,0-6.58,5,14.14,14.14,0,0,0,0,16.76,13.23,13.23,0,0,0,3,3,13.53,13.53,0,0,0,3.58,1.93,14.3,14.3,0,0,0,18.72-9.83,23.13,23.13,0,0,0,.55-3.5.64.64,0,0,1,0,.24c0,.18,0,.41,0,.68a7,7,0,0,1-.09,1.12,10.11,10.11,0,0,1-.27,1.51,13.74,13.74,0,0,1-1.56,3.9,14.63,14.63,0,0,1-3.67,4.17,14.56,14.56,0,0,1-13.85,2.16,13.64,13.64,0,0,1-3.72-2,14,14,0,0,1-3.11-3.12,14.56,14.56,0,0,1,0-17.36,13.7,13.7,0,0,1,3.11-3.11,14,14,0,0,1,3.72-2,14.66,14.66,0,0,1,7.7-.61,14.58,14.58,0,0,1,9.82,7,13.58,13.58,0,0,1,1.56,3.89,10.11,10.11,0,0,1,.27,1.51,7,7,0,0,1,.09,1.12c0,.27,0,.5,0,.69A.6.6,0,0,1,301.24,100.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.37,159.41a2.23,2.23,0,0,1-.49-.33c-.31-.23-.75-.58-1.33-1a41.55,41.55,0,0,1-4.54-4.23,16.42,16.42,0,0,1-4.28-8.12,38.79,38.79,0,0,1-.24-5.44,9.41,9.41,0,0,0-1.56-5.36,32.92,32.92,0,0,0-3.91-4.24,15.92,15.92,0,0,1-3.22-4.43,19.63,19.63,0,0,1-1.56-4.7,18.77,18.77,0,0,1-.41-4.29c0-1.33.31-2.49.43-3.51a11.9,11.9,0,0,0,.06-2.63c-.17-1.44-.45-2.21-.4-2.23a2.88,2.88,0,0,1,.22.55,11.56,11.56,0,0,1,.38,1.65,11.26,11.26,0,0,1,0,2.69c-.09,1-.33,2.2-.36,3.49a20.68,20.68,0,0,0,2,8.77,15.5,15.5,0,0,0,3.15,4.28,32.32,32.32,0,0,1,4,4.3,8.7,8.7,0,0,1,1.27,2.75,13.23,13.23,0,0,1,.37,2.89,40.47,40.47,0,0,0,.21,5.38,16.28,16.28,0,0,0,4.07,8,46.54,46.54,0,0,0,4.41,4.31L225,159A2.83,2.83,0,0,1,225.37,159.41Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,136.12a1.61,1.61,0,0,1,0,.41c0,.27,0,.66-.08,1.17a18.67,18.67,0,0,1-1,4.21,20.55,20.55,0,0,1-22.66,13.57,18.88,18.88,0,0,1-4.17-1.13c-.48-.18-.83-.38-1.07-.49s-.36-.19-.35-.21a29.57,29.57,0,0,0,5.64,1.47,21.64,21.64,0,0,0,6.29-.11,19.94,19.94,0,0,0,12.92-7.73,21.6,21.6,0,0,0,3.06-5.49A30.77,30.77,0,0,0,214,136.12Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.15,131.42a5.87,5.87,0,0,1-.29,1.37,19.8,19.8,0,0,1-1.41,3.55,23.06,23.06,0,0,1-8.52,9.13,24.85,24.85,0,0,1-12,3.52,23,23,0,0,1-3.81-.2,6.29,6.29,0,0,1-1.37-.28,51.21,51.21,0,0,0,5.17.11,25.63,25.63,0,0,0,11.75-3.6,23.72,23.72,0,0,0,8.46-8.86A39.27,39.27,0,0,0,210.15,131.42Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,121.46a3.77,3.77,0,0,1,.9-.52,8.55,8.55,0,0,1,1.11-.5,14.1,14.1,0,0,1,1.53-.54,21,21,0,0,1,4.13-.8,24.24,24.24,0,0,1,5.15.1,24.64,24.64,0,0,1,5,1.25,20.83,20.83,0,0,1,3.76,1.9,13.22,13.22,0,0,1,1.31.94,7.41,7.41,0,0,1,.93.79,4.3,4.3,0,0,1,.71.76c-.07.08-1.12-1-3.15-2.18a22.56,22.56,0,0,0-3.73-1.76,27.05,27.05,0,0,0-4.9-1.18,26.37,26.37,0,0,0-5-.15,22.87,22.87,0,0,0-4.07.69C182.26,120.86,181,121.55,180.9,121.46Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,119.61c-.09.11-6.4-5.25-14.08-12S176,95.37,176.09,95.26s6.4,5.26,14.09,12S204,119.51,203.92,119.61Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,108.66a6.16,6.16,0,0,1,2.06-2.32,6.1,6.1,0,0,1,2.72-1.5,18.31,18.31,0,0,1-2.4,1.9A19.8,19.8,0,0,1,232.73,108.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,114.29a1.23,1.23,0,0,1-.13-.2c-.09-.17-.2-.37-.34-.61a8.88,8.88,0,0,1-.78-2.56,12.8,12.8,0,0,1,2.64-9.3,14.73,14.73,0,0,1,2.23-2.41,17.82,17.82,0,0,1,2.94-2,25.93,25.93,0,0,1,7.38-2.54c5.41-1.13,11.5-.86,17.7-1.78A27.25,27.25,0,0,0,245,90.2,26,26,0,0,0,251.68,85a41.13,41.13,0,0,0,7.74-12.12c1.64-3.79,2.67-7,3.42-9.16l.85-2.53.23-.65a1.35,1.35,0,0,1,.09-.22s0,.08,0,.23l-.18.67L263,63.82a92.52,92.52,0,0,1-3.27,9.24A40.86,40.86,0,0,1,252,85.37a26.22,26.22,0,0,1-6.82,5.28,27.42,27.42,0,0,1-8.84,2.76c-6.28.94-12.34.64-17.69,1.74s-9.94,3.33-12.35,6.69a12.72,12.72,0,0,0-2.72,9A11.49,11.49,0,0,0,204.65,114.29Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,154A14.83,14.83,0,0,1,209.8,158a18.64,18.64,0,0,1-2.61,4.25,17.54,17.54,0,0,1-5.06,4.26,16.56,16.56,0,0,1-7.74,2,15.1,15.1,0,0,1-8.78-2.57,14.7,14.7,0,0,1-5.82-8.23,12.77,12.77,0,0,1-.3-5.41,13.12,13.12,0,0,1,2.09-5.18,12.52,12.52,0,0,1,7.43-5.26l0,.5a20.07,20.07,0,0,1-8.58-3.49,16.49,16.49,0,0,1-5.46-6.55,15.42,15.42,0,0,1-1.33-7.53,12.77,12.77,0,0,1,2.17-6.23,13,13,0,0,1,4-3.7,12.31,12.31,0,0,1,3.79-1.46,10.53,10.53,0,0,1,2.54-.19l.65.07a.74.74,0,0,1,.22,0,13.23,13.23,0,0,0-3.38.26,12.14,12.14,0,0,0-3.68,1.51,12.75,12.75,0,0,0-3.82,3.66,12.43,12.43,0,0,0-2.05,6.07,15.15,15.15,0,0,0,1.34,7.31,16.11,16.11,0,0,0,5.33,6.34,19.9,19.9,0,0,0,8.38,3.39l1.29.2-1.27.3a12,12,0,0,0-7.12,5.06,12.6,12.6,0,0,0-2,5,12.46,12.46,0,0,0,.28,5.2,14.23,14.23,0,0,0,5.61,8,14.71,14.71,0,0,0,8.5,2.53,16.19,16.19,0,0,0,7.57-1.91,17.29,17.29,0,0,0,5-4.11,19.19,19.19,0,0,0,2.66-4.15,22.54,22.54,0,0,0,1.11-2.92c.09-.32.16-.58.21-.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.11,110.75a.92.92,0,0,1-.24-.11l-.7-.37a18.52,18.52,0,0,1-2.49-1.71,21,21,0,0,1-6.42-9,20.8,20.8,0,0,1,7-23.64,29.27,29.27,0,0,1,9.39-4.6A52.55,52.55,0,0,1,222,69.49c3.36-.32,6.6-.47,9.68-.68a84.89,84.89,0,0,0,8.7-1,39.58,39.58,0,0,0,7.33-2A26.28,26.28,0,0,0,256.93,60a22.53,22.53,0,0,0,1.93-2.29l.46-.63a1.06,1.06,0,0,1,.17-.21,15.37,15.37,0,0,1-2.42,3.27,25.59,25.59,0,0,1-9.26,6,39.35,39.35,0,0,1-7.39,2.07,83.2,83.2,0,0,1-8.74,1c-6.15.49-13,.54-19.85,2.57a29.17,29.17,0,0,0-9.23,4.5,20.5,20.5,0,0,0-7,23.12,21.14,21.14,0,0,0,6.2,8.92,20.46,20.46,0,0,0,2.42,1.78l.66.41A1.23,1.23,0,0,1,205.11,110.75Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,96a1.29,1.29,0,0,1-.93.46,2.59,2.59,0,0,1-2.44-1.59,2.36,2.36,0,0,1,.14-2.18,4.06,4.06,0,0,1,2-1.69,6.35,6.35,0,0,1,6.11,1,6.56,6.56,0,0,1,2.27,2.93,6.93,6.93,0,0,1,.28,4,6.6,6.6,0,0,1-2.22,3.69,7.94,7.94,0,0,1-4.21,1.78,11.06,11.06,0,0,1-8.9-3.5,12.51,12.51,0,0,1-2.85-4.33,9.87,9.87,0,0,1-.5-5.31,23.37,23.37,0,0,1,1.62-5.06c.67-1.6,1.29-3.18,1.81-4.76a40.09,40.09,0,0,0,2-9.38,28.33,28.33,0,0,0-.52-8.62,22.35,22.35,0,0,0-2.85-7,19.67,19.67,0,0,0-8-7.3,18.17,18.17,0,0,0-2.79-1l-.76-.19a.9.9,0,0,1-.25-.09l.26,0,.77.14a15.54,15.54,0,0,1,2.86.95,19.54,19.54,0,0,1,8.19,7.3,22.46,22.46,0,0,1,3,7,28.55,28.55,0,0,1,.58,8.76,40.31,40.31,0,0,1-2,9.5c-.52,1.6-1.15,3.2-1.82,4.79a23.79,23.79,0,0,0-1.58,5,9.36,9.36,0,0,0,.48,5,11.81,11.81,0,0,0,2.73,4.16,10.59,10.59,0,0,0,8.47,3.39,7.53,7.53,0,0,0,4-1.66,6.16,6.16,0,0,0,2.1-3.43,6.62,6.62,0,0,0-.23-3.78,6.35,6.35,0,0,0-2.12-2.79,6,6,0,0,0-5.78-1,3.76,3.76,0,0,0-1.89,1.54,2.15,2.15,0,0,0-.18,2,2.49,2.49,0,0,0,2.25,1.56A1.8,1.8,0,0,0,316.55,96Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M310.17,322.32c4.86-1.37,9.9,3,14.83,1.87,3-.7,5.26-3.38,6.62-6.19s2.09-5.91,3.53-8.69,3.84-5.33,6.94-5.76c2.84-.38,6.21.95,8.32-1,1.63-1.5,1.41-4.28.11-6.07s-3.36-2.84-5.35-3.82a30.44,30.44,0,0,0-6.91-2.74,10.2,10.2,0,0,0-7.23.84c-4.16,2.42-5,7.91-6.21,12.57a25.18,25.18,0,0,1-4.08,9.11,13.53,13.53,0,0,1-8.24,5.32,8.9,8.9,0,0,0-3.67.94c-1.05.72-1.46,2.52-.37,3.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,304.35,303.06,298l16.33-25.53a10.87,10.87,0,0,1,7.12-4.82l29.29-5.53a4.81,4.81,0,0,1-2.51,5.87c-3.91,2.23-21.5,6.33-21.5,6.33l27.09-.46s.83,3.91-2.24,5.31-22.37,2.1-22.37,2.1L359,284.79s.14,3.93-5.51,4a163.93,163.93,0,0,1-16.65-1,.88.88,0,0,0-1,.73h0a.88.88,0,0,0,.67,1l16.43,3.88a2.2,2.2,0,0,1,.17,4.25,2.53,2.53,0,0,1-.92.06c-2.79-.28-19.52-2.4-19.52-2.4s-5.9,20.68-9.72,22.35-11.83,2.13-11.83,2.13l-17,6.73Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,273.78a6.51,6.51,0,0,1-1.42.14l-3.88.19c-3.27.14-7.8.3-12.79.43l-7.05.18a15.44,15.44,0,0,0-5.59.8,6,6,0,0,0-2.87,2.37,10.27,10.27,0,0,0-.57,1.28,1.15,1.15,0,0,1,0-.37,4.16,4.16,0,0,1,.36-1,6,6,0,0,1,2.91-2.61,15.17,15.17,0,0,1,5.72-.94l7-.22c5-.13,9.53-.23,12.8-.28l3.88,0A9,9,0,0,1,357,273.78Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,284.86a6.11,6.11,0,0,1-1.31-.09l-3.54-.45c-3-.39-7.12-1-11.67-1.66-2.27-.32-4.44-.73-6.4-.9a8.65,8.65,0,0,0-5,.9,7.85,7.85,0,0,0-2.59,2.32c-.48.68-.67,1.11-.71,1.09a1.1,1.1,0,0,1,.1-.33,5.88,5.88,0,0,1,.44-.88,7.54,7.54,0,0,1,2.58-2.52,8.77,8.77,0,0,1,5.22-1.06c2,.15,4.17.55,6.45.86,4.55.68,8.67,1.33,11.64,1.82l3.52.61A6.7,6.7,0,0,1,357.41,284.86Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,291.15a20.07,20.07,0,0,1-2.86-.62c-1.76-.43-4.18-1.07-6.86-1.62a12,12,0,0,0-1.94-.29,3.53,3.53,0,0,0-1.66.49,6,6,0,0,0-2.19,2.08,8.15,8.15,0,0,0-.87,2.72,1.7,1.7,0,0,1-.06-.8,5.31,5.31,0,0,1,.6-2.1,6.13,6.13,0,0,1,2.28-2.32,4.16,4.16,0,0,1,1.89-.58,12.64,12.64,0,0,1,2.05.28c2.72.57,5.12,1.26,6.85,1.78A14.79,14.79,0,0,1,343.66,291.15Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,318.08l54.65-6.72,95.85-15.58,12.37,31.09c-36,12.48-72.94,23.74-109.18,33.64a40.17,40.17,0,0,1-9,.76C182.18,361.32,152.34,356.46,149.59,318.08Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46,326.87a5.55,5.55,0,0,1-.25-.55c-.17-.39-.39-.93-.69-1.63-.59-1.46-1.45-3.56-2.54-6.24l-9.09-22.6.23.13-46.57,7.78c-11,1.89-21.55,3.12-31.11,4.39-4.79.63-9.33,1.26-13.56,2q-3.18.51-6.12,1a50.35,50.35,0,0,0-5.57,1.22,22.75,22.75,0,0,0-13,10.56,23.69,23.69,0,0,0-1.91,4.27c-.17.51-.28.91-.35,1.17a2.34,2.34,0,0,1-.14.4,12,12,0,0,1,.39-1.6,22.36,22.36,0,0,1,1.83-4.34,23.32,23.32,0,0,1,4.58-5.87,23.06,23.06,0,0,1,8.52-4.94,52.54,52.54,0,0,1,5.61-1.27c2-.36,4-.73,6.12-1.08,4.24-.7,8.78-1.36,13.56-2,9.57-1.29,20.11-2.53,31.09-4.43l46.59-7.67.17,0,.06.16c3.72,9.44,6.78,17.22,8.92,22.66l2.44,6.28c.27.71.47,1.26.63,1.65S312.46,326.87,312.46,326.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,359.62a2.32,2.32,0,0,1,.44.09l1.27.31c1.12.24,2.77.62,4.93.88a53.9,53.9,0,0,0,18.29-.88c1.9-.4,3.86-.94,5.91-1.52l6.38-1.8,14-4c9.89-2.88,20.74-6.11,32.09-9.64,19-5.9,36.46-11.68,50-16.35l-.12.27c-3.74-9.5-6.81-17.27-8.94-22.7-1.05-2.69-1.86-4.8-2.43-6.26-.27-.7-.47-1.24-.62-1.64s-.19-.56-.19-.56.09.18.25.54.38.93.67,1.62l2.53,6.21,9.11,22.64.08.2-.2.07c-13.56,4.74-31,10.55-50,16.46-11.35,3.53-22.21,6.75-32.11,9.61l-14.08,4-6.39,1.76c-2,.57-4,1.11-5.93,1.5a53.3,53.3,0,0,1-18.4.73A34.87,34.87,0,0,1,179,359.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,311.36a6.54,6.54,0,0,1-1.37.21l-3.75.37-12.36,1.21-12.36,1.32-3.75.39a6.23,6.23,0,0,1-1.38.08,8.29,8.29,0,0,1,1.36-.28c.88-.14,2.15-.33,3.73-.55,3.15-.44,7.51-1,12.34-1.47s9.22-.85,12.39-1.06c1.59-.11,2.88-.18,3.77-.22A8.12,8.12,0,0,1,200.18,311.36Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "plant",
    "data-motion": "sway",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.69,411.61c-2.76,3.95-8.14,2.64-10.63.23s-3.54-5.9-4.5-9.23c-2.19-7.61-4.4-15.59-2.77-23.34a13,13,0,0,1,3-6.35,6.76,6.76,0,0,1,6.42-2.13c2.71.71,4.39,3.36,5.61,5.89a55.62,55.62,0,0,1,5.5,23.88c0,3.84-.44,7.88-2.61,11.05",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.69,411.61c-2.76,3.95-8.14,2.64-10.63.23s-3.54-5.9-4.5-9.23c-2.19-7.61-4.4-15.59-2.77-23.34a13,13,0,0,1,3-6.35,6.76,6.76,0,0,1,6.42-2.13c2.71.71,4.39,3.36,5.61,5.89a55.62,55.62,0,0,1,5.5,23.88c0,3.84-.44,7.88-2.61,11.05"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,431.6c-4.52-2.33-9.84-2.63-14.86-1.8-2.69.44-5.51,1.25-7.34,3.28s-2.18,5.59-.08,7.33a7.08,7.08,0,0,0,4.63,1.17c3.93-.05,8.29-.74,11.43,1.63,1.79,1.34,3,3.59,5.12,4.25A5.06,5.06,0,0,0,98.8,445a8.63,8.63,0,0,0,.63-6.38A9.74,9.74,0,0,0,94.33,431.6Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28,417.28c-3-3.57-3.57-8.76-2.23-13.22s4.35-8.26,7.82-11.36a42.17,42.17,0,0,1,14-8.27,14.7,14.7,0,0,1,6.3-1.07,6.59,6.59,0,0,1,5.29,3.2c1.48,2.81.06,6.23-1.47,9a105.85,105.85,0,0,1-9.21,14c-2.76,3.56-5.92,7.07-10.12,8.68s-8.58,1.42-10.81-1.5",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,471.16a8.17,8.17,0,0,1-.25-1.79c-.13-1.3-.29-2.94-.48-4.89a72,72,0,0,0-1.1-7.19,55.17,55.17,0,0,0-2.61-8.47,31.31,31.31,0,0,0-4.33-7.67,16.22,16.22,0,0,0-5.47-4.55A15.27,15.27,0,0,0,86,435.17a8.78,8.78,0,0,1-1.78-.26,8.45,8.45,0,0,1,1.81,0,14,14,0,0,1,4.81,1.25,16.16,16.16,0,0,1,5.77,4.59,30.5,30.5,0,0,1,4.49,7.82,53,53,0,0,1,2.59,8.62,60.47,60.47,0,0,1,1,7.27c.16,2.08.22,3.76.24,4.92A8.45,8.45,0,0,1,104.88,471.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54,467.4a3.38,3.38,0,0,1-.05-.83c0-.63,0-1.42,0-2.39,0-2.06,0-5.05-.11-8.74-.18-7.38-.82-17.58-2-28.78S99.47,405.38,98,398.15c-.36-1.82-.71-3.45-1-4.88s-.59-2.66-.85-3.66-.41-1.71-.56-2.32a4,4,0,0,1-.15-.82,3.23,3.23,0,0,1,.29.78c.19.6.41,1.36.7,2.28s.62,2.22,1,3.65.77,3.05,1.16,4.86a270,270,0,0,1,4.59,28.54c1.23,11.23,1.79,21.45,1.84,28.85,0,3.7,0,6.7-.13,8.76-.06,1-.11,1.76-.15,2.38A3.29,3.29,0,0,1,104.54,467.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,447.68a16.2,16.2,0,0,1,0-2.48c.09-1.6.31-3.91.76-6.74a88.82,88.82,0,0,1,2.19-9.81,87.55,87.55,0,0,1,4.1-11.62,62,62,0,0,1,12.06-18.77,29.85,29.85,0,0,1,2.83-2.63c.44-.37.82-.74,1.21-1l1.1-.76a17.08,17.08,0,0,1,2.1-1.34c.12.17-3,2-6.86,6.13a65.15,65.15,0,0,0-11.76,18.7,91.94,91.94,0,0,0-4.12,11.5,99.61,99.61,0,0,0-2.34,9.72c-.51,2.8-.81,5.09-1,6.67A15.06,15.06,0,0,1,104.49,447.68Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "heart",
    "data-motion": "float",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.58,130.6c-1-7.93-7.69-15.32-15.68-15.32-4.71,0-9.2,2.46-12.42,5.91a31.44,31.44,0,0,0-3.15,3.73,32.17,32.17,0,0,0-2.36-4.28c-2.48-4-6.39-7.31-11-8.24-7.84-1.56-15.86,4.36-18.39,11.94s-.42,16.08,3.73,22.9,11.3,15.75,24.47,20.17c9.07-1.16,21.23-9.21,26.64-15.09S396.56,138.53,395.58,130.6Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7,144.83h-.26l-.77-.05-3-.25-10.86-1,.19-.12-4.52,11.8-.28.71-.18-.74c-1.37-5.73-2.92-12.14-4.55-18.9L367,130.13l.46.1-8.29,11.4-.08.1H359l-19.09-2-5.4-.6-1.43-.18-.49-.09a2.7,2.7,0,0,1,.5,0l1.43.11,5.42.47,19.1,1.8-.21.1,8.25-11.43.33-.45.13.54c.48,2,1,4.07,1.48,6.17,1.61,6.76,3.14,13.18,4.51,18.91l-.46,0,4.62-11.77.05-.13h.14l10.85,1.16,2.95.35.76.1Z",
    style: {
      fill: "#F6F9FC"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "tube",
    "data-motion": "float",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.13,288.41H109a0,0,0,0,1,0,0v9.7a4.45,4.45,0,0,1-4.45,4.45h-8a4.45,4.45,0,0,1-4.45-4.45v-9.7a0,0,0,0,1,0,0Z",
    transform: "translate(88.05 -16.4) rotate(16.5)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,288.41H109a0,0,0,0,1,0,0v9.71a4.43,4.43,0,0,1-4.43,4.43h-8a4.43,4.43,0,0,1-4.43-4.43v-9.71A0,0,0,0,1,92.13,288.41Z",
    transform: "translate(88.05 -16.4) rotate(16.5)",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,300.39a67.24,67.24,0,0,1-8.2-2.15,69,69,0,0,1-8-2.66,69.06,69.06,0,0,1,8.2,2.16A70.25,70.25,0,0,1,108.12,300.39Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,297h0a2,2,0,0,1,2.47-1.41l3.24,1a2,2,0,0,1,1.3,2.52h0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,207.73l-18,74.41a6.33,6.33,0,0,0,4.21,7.64l11.79,3.5a6.32,6.32,0,0,0,7.6-3.88l28.27-71.65Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.47,223.65c0,.14-7.46-1.94-16.57-4.64s-16.47-5-16.43-5.14,7.46,1.94,16.58,4.64S141.51,223.51,141.47,223.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,214.72a10,10,0,0,1,.66-3.13,10.4,10.4,0,0,1,1.15-3,9.81,9.81,0,0,1-.65,3.13A9.93,9.93,0,0,1,111.07,214.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,215.51a19.23,19.23,0,0,1,1.81-6.11,10,10,0,0,1-.66,3.13A10.26,10.26,0,0,1,113.76,215.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.44,216.31a10,10,0,0,1,.66-3.13,10.08,10.08,0,0,1,1.15-3,9.81,9.81,0,0,1-.65,3.13A9.93,9.93,0,0,1,116.44,216.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.13,217.1a19.23,19.23,0,0,1,1.81-6.11,19.94,19.94,0,0,1-1.81,6.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,217.9a10,10,0,0,1,.66-3.13,10.08,10.08,0,0,1,1.15-3,9.81,9.81,0,0,1-.65,3.13A9.93,9.93,0,0,1,121.81,217.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,218.69a19.23,19.23,0,0,1,1.81-6.11,19.94,19.94,0,0,1-1.81,6.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.18,219.49a10,10,0,0,1,.66-3.13,10.08,10.08,0,0,1,1.15-3,9.81,9.81,0,0,1-.65,3.13A9.93,9.93,0,0,1,127.18,219.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86,220.28a10.36,10.36,0,0,1,.66-3.13,9.8,9.8,0,0,1,1.16-3,10.36,10.36,0,0,1-.66,3.13A9.8,9.8,0,0,1,129.86,220.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,221.08a9.77,9.77,0,0,1,.65-3.13,10.25,10.25,0,0,1,1.16-3,10,10,0,0,1-.66,3.13A10.08,10.08,0,0,1,132.55,221.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,221.87a19.94,19.94,0,0,1,1.81-6.11,19.23,19.23,0,0,1-1.81,6.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,222.67a9.77,9.77,0,0,1,.65-3.13,9.93,9.93,0,0,1,1.16-3,10,10,0,0,1-.66,3.13A10.08,10.08,0,0,1,137.92,222.67Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,223.46a19.94,19.94,0,0,1,1.81-6.11,19.23,19.23,0,0,1-1.81,6.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.28 246.63 115.55 242.37 119.76 243.62 118.58 247.61 122.02 248.62 120.78 252.81 116.97 251.69 115.89 255.34 112.37 254.29 113.53 250.37 109.38 249.14 110.48 245.43 114.28 246.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,251.44c-.06,0,.22-.8.29-2.27a9.51,9.51,0,0,0-1.7-5.82,8.81,8.81,0,0,0-3.14-2.78,8.7,8.7,0,0,0-4.69-.93,9,9,0,0,0-4.88,2A9.57,9.57,0,0,0,107.27,252a8.93,8.93,0,0,0,3,4.32,8.76,8.76,0,0,0,4.44,1.77,8.87,8.87,0,0,0,4.15-.61,9.46,9.46,0,0,0,4.59-4c.75-1.27.94-2.08,1-2.06a2.2,2.2,0,0,1-.14.58,8.12,8.12,0,0,1-.68,1.58,9.53,9.53,0,0,1-4.63,4.21,9,9,0,0,1-9-1.12,9.37,9.37,0,0,1-3.2-4.54A10,10,0,0,1,110,241.23a9.32,9.32,0,0,1,5.16-2.07,9.06,9.06,0,0,1,4.93,1,9.25,9.25,0,0,1,3.25,2.95,9.5,9.5,0,0,1,1.59,6,8.7,8.7,0,0,1-.29,1.7A2.09,2.09,0,0,1,124.46,251.44Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.8f4f83ce70bc7e44954eca41d58de474.svg";
export { ForwardRef as ReactComponent };